// /audit/exports — «Мои выгрузки» (002): свои заказы выгрузки журнала в фоне. Право — audit.export;
// какие заказы видны и чей файл выдаётся, решает сервер: только свои (FR-054, FR-056).
// «audit_» — отдельная страница, а не вложенная в журнал: журнал не держит место под неё.
// ?focus=<номер заказа> — строка заказа из уведомления о неудаче (FR-053а).
import { createFileRoute } from '@tanstack/react-router';
import { ExportsPage, parseExportsSearch } from '../../../features/audit/ExportsPage.tsx';
import { requireSection } from '../../../shell/permissions.ts';

export const Route = createFileRoute('/_app/_settings/audit_/exports')({
  validateSearch: parseExportsSearch,
  beforeLoad: requireSection('exports'),
  staticData: { crumb: 'Мои выгрузки' },
  component: ExportsRoute,
});

function ExportsRoute() {
  const { focus } = Route.useSearch();
  return <ExportsPage {...(focus ? { focus } : {})} />;
}
